/**
 * 拦截跨域 opaque Script error.，避免 @didi/error-base 当成崩溃上报。
 * 浏览器已清空 filename / 行列 / error，无法再还原来源。
 */

const RESOURCE_NODE_NAMES: Record<string, 1> = {
    SCRIPT: 1,
    LINK: 1,
    IMG: 1
};

const isResourceErrorTarget = (target: EventTarget | null): boolean => {
    if (!target || target === window) {
        return false;
    }

    const nodeName = (target as Node).nodeName;

    return RESOURCE_NODE_NAMES[nodeName] === 1;
};

/** HTML 标准 opaque 事件：message="Script error."、空 filename、0:0、无 error */
export const isOpaqueScriptError = (event: ErrorEvent): boolean => {
    if (isResourceErrorTarget(event.target)) {
        return false;
    }

    return (
        event.message === 'Script error.' &&
        !event.filename &&
        event.lineno === 0 &&
        event.colno === 0 &&
        !event.error
    );
};

const onOpaqueScriptError = (event: Event) => {
    if (!(event instanceof ErrorEvent)) {
        return;
    }

    if (!isOpaqueScriptError(event)) {
        return;
    }

    event.stopImmediatePropagation();

    if (typeof event.preventDefault === 'function') {
        event.preventDefault();
    }
};

/** 捕获阶段拦截，须在 initErrorMonitor / error-base 之前注册 */
export const installSilentOpaqueScriptErrorGuard = (): (() => void) => {
    window.addEventListener('error', onOpaqueScriptError, true);

    return () => {
        window.removeEventListener('error', onOpaqueScriptError, true);
    };
};
